import { call, put, takeLatest } from "redux-saga/effects";
import { ManagerOverallCostDetailAction } from "../../../actions";
import * as types from "../../../actions/actionTypes";
import * as overallCostDetailApi from "../../../api/overallCost/detail/managerOverallCostDetail";
import { GetFilterDetail } from "../../../hocs/costClassificationReport/components/filter/tools";
import { SetMessage } from "../../../assets/errorMessages";

export function* managerWatcherOverallCostDetail() {
  yield takeLatest(types.MANAGER_GET_OVERALL_COST_DETAIL_REQUEST, worker);
}

async function fetchList(pageNumber = null) {
  const page_number = pageNumber ? pageNumber : "";
  return overallCostDetailApi.getList(page_number, GetFilterDetail());
}

function* worker(action) {
  try {
    const response = yield call(fetchList, action.pageNumber);
    yield put(ManagerOverallCostDetailAction.getSuccess(response.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(ManagerOverallCostDetailAction.getFailure(message));
  }
}
